module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('关注列表'),
      expression: "'关注列表'"
    }],
    staticClass: "care"
  }, [_c('navtop'), _vm._v(" "), _c('div', {
    staticClass: "wrap",
    style: ('overflow:scroll;-webkit-overflow-scrolling: touch;')
  }, [_c('div', {
    staticClass: "focus"
  }, [_vm._l((_vm.attentList), function(item) {
    return _c('div', {
      class: item.isOnline == 0 ? 'offLine' : 'fff'
    }, [_c('a', {
      attrs: {
        "href": item.isOnline == 1 ? (_vm.protocol + '//h5.qxiu.com/room.html?roomid=' + item.roomId + '&channelid=' + _vm.channelid) : 'javascript:void(0)'
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": 'https://qiqi-resource-v6.qxiu.com' + item.picUrl_L.slice(29) || 'https://static.qxiu.com/h5/static/sDefault.png'
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "roomInfo"
    }, [_c('span', [_vm._v(_vm._s(item.anchorNickName.slice(0, 6)))]), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": require("../../img/dating/viewer.png")
      }
    }), _vm._v(_vm._s(item.isOnline == 0 ? 0 : item.roomNum))])]), _vm._v(" "), (item.isOnline != 0) ? _c('span') : _vm._e()])
  }), _vm._v(" "), (_vm.onlingAttentList.length == 0) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("还没有关注主播哦~")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "recommend"
  }, [_c('p'), _vm._v(" "), _c('ul', {
    staticClass: "recomList"
  }, _vm._l((_vm.recomList), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.protocol + '//h5.qxiu.com/room.html?roomid=' + item.roomId
      }
    }, [_c('img', {
      attrs: {
        "src": 'https://qiqi-resource-v6.qxiu.com' + JSON.parse(item.anchorPic)[0].slice(29)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "roomInfo"
    }, [_c('span', [_vm._v(_vm._s(item.anchorName.slice(0, 6)))]), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": require("../../img/dating/viewer.png")
      }
    }), _vm._v(_vm._s(item.isOnline == 0 ? 0 : item.roomNum))])]), _vm._v(" "), _c('span', {
      staticClass: "live"
    })])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7209a02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/care.vue
// module id = 125
// module chunks = 0